export default __webpack_public_path__ + "e7473ecc0230c284ba244dcbf67e48d0.svg";